import(/* webpackMode: "eager" */ "/home/trt20210034/Desktop/p-dsp/linqops/app/forgot-password/page.tsx");
